import SHA256 from "crypto-js/sha256";
import { getUserEnv } from "./getUserEnv";
import {
  DEFAULT_LOCALE,
  getBaseLang,
  getCurrency,
  getLocaleFromPath,
} from "../../config/locales";

// Check if Clarity is loaded
const isClarityLoaded = () => typeof window.clarity === "function";

/**
 * Resolve the active route locale. Centralized so every tracking helper agrees
 * on the same source of truth and never leaks `"uk"` into analytics.
 */
const resolveActiveLocale = (locale) =>
  locale ?? getLocaleFromPath(window.location.pathname) ?? DEFAULT_LOCALE;

// Set custom tags in Clarity
export const setClarityTags = (user, locale) => {
  if (!isClarityLoaded()) return;

  const activeLocale = resolveActiveLocale(locale);
  const email = user?.email || "";
  const hashedEmail = email
    ? SHA256(email.trim().toLowerCase()).toString()
    : null;

  if (hashedEmail) {
    window.clarity("set", "user_email_hash", hashedEmail);
  }

  window.clarity("set", "user_env", getUserEnv());
  window.clarity("set", "user_language", getBaseLang(activeLocale));
  window.clarity("set", "currency", getCurrency(activeLocale));
};

// Track custom events in Clarity
export const trackClarityEvent = (eventName, eventData = {}) => {
  if (!isClarityLoaded()) return;

  window.clarity("event", eventName, eventData);
};

// Identify user in Clarity
export const identifyClarityUser = (userId) => {
  if (!isClarityLoaded()) return;

  window.clarity("identify", userId, {
    timestamp: new Date().toISOString(),
  });
};
